module.exports = __webpack_public_path__ + "static/media/Diyatha-Station.7e27c90b.webp";